// @ts-strict-ignore
import { captureException } from '@sentry/nextjs';
import actionTypes from 'src/modules/user/shared/actionTypes';
import { setAlert } from 'src/components/alert/actions';
import { del, post, put } from 'src/utils/api';
import { ReduxState } from 'src/store/store';

export const addConditions = (conditions) => {
  return async (dispatch, getState: () => ReduxState) => {
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      const { data } = await post(`private/users/${currentUser.userId}/profile`, {
        'profile-data': { conditions },
      });
      dispatch({
        type: actionTypes.ADD_PROFILE_CONDITIONS_SUCCESS,
        condition: data.conditions[0],
      });
    } catch (ex) {
      captureException(ex);
      dispatch(setAlert());
    }
  };
};

export const updateCondition = (id, conditionData) => {
  return async (dispatch, getState: () => ReduxState) => {
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      const { data } = await put(`private/users/${currentUser.userId}/profile/conditions/${id}`, {
        condition: conditionData,
      });
      dispatch({
        type: actionTypes.UPDATE_PROFILE_CONDITION_SUCCESS,
        condition: data,
      });
    } catch (ex) {
      captureException(ex);
      dispatch(setAlert());
    }
  };
};

export const deleteCondition = (id) => {
  return async (dispatch, getState: () => ReduxState) => {
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      await del(`private/users/${currentUser.userId}/profile/conditions/${id}`);
      dispatch({
        type: actionTypes.DELETE_PROFILE_CONDITION_SUCCESS,
        id,
      });
    } catch (ex) {
      captureException(ex);
      dispatch(setAlert());
    }
  };
};
